<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import _ from 'lodash';
export default {
  computed: {
    loading: function() {
      return this.$root.loading;
    },
  },
};
</script>

<style lang="scss">
@import './main.scss';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
</style>
